Vendd.Scripts.load(function () {
    var $form = $('.x-multisite-selector'), form, formData;

    if ($form.length < 1)
        return;

    var countrySelector = $(".js-selector.country", $form);
    var languageSelector = $(".js-selector.language", $form);
    var siteSelector = $(".js-selector.site", $form);
    var redirectButton = $(".js-redirect-btn", $form);

    form = $form.get(0);

    var countries = countrySelector.prop("options");
    var languages = languageSelector.prop("options");
    var sites = siteSelector.prop("options");

    countrySelector.change(function () {
        $("option", languageSelector).not("[value='0']").remove();
        $("option", siteSelector).not("[value='0']").remove();

        multisiteData.selectedCountry = $("option:selected", $(this)).val();

        if (multisiteData.selectedCountry != 0) {

            var result = filterData(multisiteData.selectedCountry, null, null);

            for (d in result.languages) languages[languages.length] = new Option(
                multisiteData.languages[d].name + (multisiteData.languages[d].name === multisiteData.languages[d].nativeName ? '' : ' - ' + multisiteData.languages[d].nativeName)
                , d);

            if (multisiteData.countries[multisiteData.selectedCountry].defaultLanguage) {
                languageSelector.val(multisiteData.countries[multisiteData.selectedCountry].defaultLanguage);

                for (d in result.sites) sites[sites.length] = new Option(multisiteData.sites[d].name, d);

                if (Object.keys(result.sites).length == 1) {
                    siteSelector.val(Object.keys(result.sites)[0]).closest('.form-row').addClass('hidden');
                } else {
                    siteSelector.closest('.form-row').removeClass('hidden');
                }

                siteSelector.removeAttr('disabled').closest('.select-wrapper').removeClass('disabled');
            } else {
                if (Object.keys(result.languages).length == 1) {
                    languageSelector.val(Object.keys(result.languages)[0]);

                    for (d in result.sites) sites[sites.length] = new Option(multisiteData.sites[d].name, d);

                    if (Object.keys(result.sites).length == 1) {
                        siteSelector.val(Object.keys(result.sites)[0]).closest('.form-row').addClass('hidden');
                    } else {
                        siteSelector.closest('.form-row').removeClass('hidden');
                    }

                    siteSelector.removeAttr('disabled').closest('.select-wrapper').removeClass('disabled');
                }
                else {
                    siteSelector.prop('disabled', true).closest('.select-wrapper').addClass('disabled');
                }
            }
            
            languageSelector.removeAttr('disabled').closest('.select-wrapper').removeClass('disabled');

        } else {
            languageSelector.prop('disabled', true).closest('.select-wrapper').addClass('disabled');
            siteSelector.prop('disabled', true).closest('.select-wrapper').addClass('disabled');
        }

        bindRedirectButton();
    });

    languageSelector.change(function () {

        $("option", siteSelector).not("[value='0']").remove();

        multisiteData.selectedLanguage = $("option:selected", $(this)).val();

        if (multisiteData.selectedLanguage != 0) {

            var result = filterData(multisiteData.selectedCountry, multisiteData.selectedLanguage, null);

            for (d in result.sites) sites[sites.length] = new Option(multisiteData.sites[d].name, d); 

            if (Object.keys(result.sites).length == 1) {
                siteSelector.val(Object.keys(result.sites)[0]).closest('.form-row').addClass('hidden');
            } else {
                siteSelector.closest('.form-row').removeClass('hidden');
            }

            siteSelector.removeAttr('disabled').closest('.select-wrapper').removeClass('disabled');
        } else {
            siteSelector.prop('disabled', true).closest('.select-wrapper').addClass('disabled');
        }

        bindRedirectButton();
    });

    siteSelector.change(function () {
        bindRedirectButton();
    });

    if (multisiteData.countries[multisiteData.geoCountry]) {
        countrySelector.val(multisiteData.geoCountry);
        countrySelector.change();
    }

    function filterData(cv, lv, sv) {
        var distinct = { countries: {}, languages: {}, sites: {} };
        var fdata = multisiteData.combinations.filter(function (o) {
            return (cv ? o.country === cv : true) && (lv ? o.language === lv : true) && (sv ? o.site === sv : true);
        });
        fdata
            .map(function (o) { return o.country; })
            .filter(function (o, i, s) { return s.indexOf(o) === i; })
            .map(function (o) {
                distinct.countries[o] = multisiteData.countries[o];
            });
        fdata
            .map(function (o) { return o.language; })
            .filter(function (o, i, s) { return s.indexOf(o) === i; })
            .map(function (o) {
                distinct.languages[o] = multisiteData.languages[o];
            });
        fdata
            .map(function (o) { return o.site; })
            .filter(function (o, i, s) { return s.indexOf(o) === i; })
            .map(function (o) {
                distinct.sites[o] = multisiteData.sites[o];
            });
        return distinct;
    }

    function bindRedirectButton() {
        multisiteData.selectedCountry = $("option:selected", countrySelector).val();
        multisiteData.selectedLanguage = $("option:selected", languageSelector).val();
        multisiteData.selectedSite = $("option:selected", siteSelector).val();

        if (multisiteData.selectedCountry && multisiteData.selectedCountry != "0" && multisiteData.selectedLanguage && multisiteData.selectedLanguage != "0" && multisiteData.selectedSite && multisiteData.selectedSite != "0") {
            redirectButton.removeClass('disabled').attr("href", "//" + multisiteData.sites[multisiteData.selectedSite].url + "/" + multisiteData.selectedLanguage);
        }
        else {
            redirectButton.addClass('disabled').attr("href", "javascript:void(0)");
        }
    }
});

